
import React, { useEffect, useRef, useState } from "react";

const WinLines = ({ Winsdata, IndexWinsIcons }) => {
  const ICON_WIDTH = Winsdata.ICON_WIDTH
  const ICON_HEIGHT = Winsdata.ICON_HEIGHT
  const ICON_SPACING_X = Winsdata.ICON_SPACING_X
  const ICON_SPACING_Y = Winsdata.ICON_SPACING_Y
  const X_OFFSET = Winsdata.X_OFFSET
  const lines_gm = Winsdata.Winning_Lines
  const ctx = Winsdata.ctx
  const reelData = Winsdata.reelData
  const DUMMY_LENGTH = Winsdata.DUMMY_LENGTH
  const preloadedImages = Winsdata.preloadedImages
  const pulseIndexes = Winsdata.Winning_pulseIcons
  // const pulseIndexes = IndexWinsIcons
  const ICON_CENTER = Winsdata.ICON_CENTER
  const spinDirection = Winsdata.DirectionSpin
  useEffect(() => {
    let animationFrameId;

    const animate = () => {
      highlightWinningIcons();
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(animationFrameId);
  }, [Winsdata]);

  const highlightWinningIcons = () => {
    const lines = lines_gm;
    if (!lines.length) return;

    lines.forEach(line => {
      line.positions.forEach(([reelIndex, rowIndex], iconIndex) => {
        const x = reelIndex * (ICON_WIDTH + ICON_SPACING_X) + X_OFFSET;
        const y = rowIndex * (ICON_HEIGHT + ICON_SPACING_Y);

        const center_iconX = x + ICON_CENTER;
        const center_iconY = y + ICON_CENTER;

        // const iconKey = reelData.current[reelIndex][rowIndex + DUMMY_LENGTH];
        const iconArrayIndex =
          spinDirection === 'up'
            ? rowIndex + DUMMY_LENGTH   // UP
            : rowIndex;                // DOWN

        const iconKey = reelData.current[reelIndex][iconArrayIndex];


        const img = preloadedImages.current[iconKey];

        // 👉 CHOOSE which icons pulse:
        // Example: pulse only 1st & 4th icons of each line
        const shouldPulse = pulseIndexes.includes(iconIndex);

        if (shouldPulse) {
          // === BLUR ONLY BACKGROUND ===
          ctx.save();
          ctx.filter = 'blur(8px)';
          ctx.fillStyle = 'rgba(0, 0, 0, 0)';
          ctx.fillRect(x, y, ICON_WIDTH, ICON_HEIGHT);
          ctx.restore();

          // === PULSE ANIMATION + GLOW ===
          ctx.save();
          const centerX = x + ICON_WIDTH / 2;
          const centerY = y + ICON_HEIGHT / 2;
          ctx.translate(centerX, centerY);

          const pulseSpeed = 1000;
          const offset = (reelIndex + rowIndex) * 15;
          const scale =
            1.05 +
            0.1 *
            Math.sin(
              (((Date.now() + offset) % pulseSpeed) / pulseSpeed) *
              2 *
              Math.PI
            );

          ctx.scale(scale, scale);
          ctx.translate(-centerX, -centerY);

          ctx.shadowColor = 'yellow';
          ctx.shadowBlur = 25;
          ctx.drawImage(img, center_iconX, center_iconY, ICON_WIDTH, ICON_HEIGHT);
          // ctx.drawImage(img, x, y, ICON_WIDTH, ICON_HEIGHT);
          ctx.restore();

          // === OUTLINE BORDER ===
          // ctx.save();
          // ctx.lineWidth = 1;
          // ctx.strokeStyle = 'rgba(255,255,0,0.7)';
          // ctx.shadowColor = 'yellow';
          // ctx.shadowBlur = 15;
          // ctx.strokeRect(x, y, ICON_WIDTH, ICON_HEIGHT);
          // ctx.restore();
        } else {
          // === Draw normal icon (no pulse) ===
          ctx.save();
           ctx.drawImage(img, center_iconX, center_iconY, ICON_WIDTH, ICON_HEIGHT);
          // ctx.drawImage(img, x, y, ICON_WIDTH, ICON_HEIGHT);
          ctx.restore();
        }
      });
    });
  };

}
export default WinLines